var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "row" }, [
        _vm.showAge
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("label", { staticClass: "inbox-label" }, [
                  _vm._v(_vm._s(_vm.t("application.age"))),
                ]),
                _vm._v(" "),
                _c("IntegerInput", {
                  attrs: {
                    fieldTitle: _vm.t("application.age", {}, "zh"),
                    fieldname: "age",
                    name: "age",
                    min: "16",
                    max: "120",
                  },
                  model: {
                    value: _vm.age,
                    callback: function ($$v) {
                      _vm.age = $$v
                    },
                    expression: "age",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
          _c("label", { staticClass: "inbox-label" }, [
            _vm._v(_vm._s(_vm.t("application.born_in_hk"))),
          ]),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "radio-group" }, [
            _c("label", { staticClass: "btn-radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.bornInHKVal,
                    expression: "bornInHKVal",
                  },
                ],
                attrs: {
                  fieldTitle: _vm.t("application.born_in_hk", {}, "zh"),
                  fieldValue: _vm.bornInHKVal,
                  name: "born-in-hk",
                  type: "radio",
                  value: "yes",
                  fieldname: "bornInHk",
                  fieldType: "isBornInHK",
                  "field-single": "",
                },
                domProps: { checked: _vm._q(_vm.bornInHKVal, "yes") },
                on: {
                  change: function ($event) {
                    _vm.bornInHKVal = "yes"
                  },
                },
              }),
              _vm._v("\n            " + _vm._s(_vm.t("common.yes")) + " "),
            ]),
            _c("label", { staticClass: "btn-radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.bornInHKVal,
                    expression: "bornInHKVal",
                  },
                ],
                attrs: {
                  fieldTitle: _vm.t("application.born_in_hk", {}, "zh"),
                  fieldValue: _vm.bornInHKVal,
                  fieldname: "bornInHk",
                  fieldType: "isBornInHK",
                  "field-single": "",
                  name: "born-in-hk",
                  type: "radio",
                  value: "no",
                },
                domProps: { checked: _vm._q(_vm.bornInHKVal, "no") },
                on: {
                  change: function ($event) {
                    _vm.bornInHKVal = "no"
                  },
                },
              }),
              _vm._v(
                "\n            " + _vm._s(_vm.t("common.no")) + "\n          "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6 col-xs-12" }, [
          _c("label", { staticClass: "inbox-label" }, [
            _vm._v(_vm._s(_vm.t("application.invitation_code"))),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inviteCodeVal,
                expression: "inviteCodeVal",
              },
            ],
            staticClass: "form-control",
            attrs: {
              id: "invCode-txt",
              fieldTitle: _vm.t("application.invitation_code", {}, "zh"),
              fieldname: "inviteCode",
              name: "inviteCode",
              type: "text",
              maxlength: "300",
            },
            domProps: { value: _vm.inviteCodeVal },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.inviteCodeVal = $event.target.value
              },
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.bornInHKVal == "yes"
      ? _c("input", {
          attrs: {
            value: "yes",
            type: "hidden",
            name: "permanentHkid",
            fieldname: "permanentHkid",
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "row" }, [
        _vm.bornInHKVal === "no"
          ? _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
              _c("label", { staticClass: "inbox-label" }, [
                _vm._v(_vm._s(_vm.t("application.permanent_hkid"))),
              ]),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "radio-group" }, [
                _c("label", { staticClass: "btn-radio" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.permanentVal,
                        expression: "permanentVal",
                      },
                    ],
                    attrs: {
                      fieldTitle: _vm.t("application.permanent_hkid", {}, "zh"),
                      fieldValue: _vm.permanentVal,
                      name: "permanent",
                      type: "radio",
                      value: "yes",
                      fieldname: "permanentHkid",
                      fieldType: "isHKPermanentResident",
                      "field-single": "",
                    },
                    domProps: { checked: _vm._q(_vm.permanentVal, "yes") },
                    on: {
                      change: function ($event) {
                        _vm.permanentVal = "yes"
                      },
                    },
                  }),
                  _vm._v("\n            " + _vm._s(_vm.t("common.yes")) + " "),
                ]),
                _c("label", { staticClass: "btn-radio" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.permanentVal,
                        expression: "permanentVal",
                      },
                    ],
                    attrs: {
                      fieldTitle: _vm.t("application.permanent_hkid", {}, "zh"),
                      fieldValue: _vm.permanentVal,
                      fieldname: "permanentHkid",
                      fieldType: "isHKPermanentResident",
                      "field-single": "",
                      name: "permanent",
                      type: "radio",
                      value: "no",
                    },
                    domProps: { checked: _vm._q(_vm.permanentVal, "no") },
                    on: {
                      change: function ($event) {
                        _vm.permanentVal = "no"
                      },
                    },
                  }),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.t("common.no")) +
                      "\n          "
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.bornInHKVal === "no" && _vm.permanentVal === "no"
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("label", { staticClass: "inbox-label" }, [
                  _vm._v(_vm._s(_vm.t("application.visa_validity_period"))),
                ]),
                _vm._v(" "),
                _c("IntegerInput", {
                  attrs: {
                    fieldTitle: _vm.t(
                      "application.visa_validity_period",
                      {},
                      "zh"
                    ),
                    label: _vm.t("common.year_unit"),
                    fieldname: "visaValidityPeriod",
                    name: "validity",
                  },
                  model: {
                    value: _vm.validityPeriodVal,
                    callback: function ($$v) {
                      _vm.validityPeriodVal = $$v
                    },
                    expression: "validityPeriodVal",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }